module.exports = __webpack_public_path__ + "static/media/Caret.957fbb70.svg";